import { render, staticRenderFns } from "./Preparatoria.vue?vue&type=template&id=5730f4cf&scoped=true"
import script from "./Preparatoria.vue?vue&type=script&lang=js"
export * from "./Preparatoria.vue?vue&type=script&lang=js"
import style0 from "./Preparatoria.vue?vue&type=style&index=0&id=5730f4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730f4cf",
  null
  
)

export default component.exports